import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { bannerComponentMap, LayoutElementBanner } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Banner/LayoutElementBanner";
import { Container } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Container";
import { LayoutElementProvider, LayoutElementRendererData } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import * as React from "react";
export var LayoutElementBasedBanner = function(props) {
    var className = props.className, rest = _object_without_properties(props, [
        "className"
    ]);
    var layoutElementProps = LayoutElementRendererData.build(rest);
    return /*#__PURE__*/ _jsx(LayoutElementProvider, _object_spread_props(_object_spread({}, layoutElementProps), {
        children: /*#__PURE__*/ _jsx(Container, {
            className: className,
            children: /*#__PURE__*/ _jsx(LayoutElementBanner, {})
        })
    }));
};
export var isSupportedBanner = function(type) {
    return bannerComponentMap.has(type);
};
